/* LL Brief 89C: never leave a broken Shopify Files image in the payment area. */
(() => {
  if (window.LLFooterPaymentImage) return;
  window.LLFooterPaymentImage = true;

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-ll-stitch]').forEach(wrapper => {
      if (wrapper.dataset.llReady === 'true') return;
      wrapper.dataset.llReady = 'true';
      const image = wrapper.querySelector('img');
      const fallback = wrapper.querySelector('[data-ll-stitch-fallback]');
      if (!image || !fallback) return;

      const showFallback = () => {
        image.hidden = true;
        fallback.hidden = false;
      };
      image.addEventListener('error', showFallback, { once:true });
      if (image.complete && image.naturalWidth === 0) showFallback();
    });
  };

  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
